<template>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
        <path
            d="M11.0174 4.31707C11.3553 3.73171 12.2002 3.73171 12.5382 4.31707L22.9493 22.3496C23.2872 22.935 22.8648 23.6667 22.1889 23.6667H1.3667C0.690773 23.6667 0.268323 22.935 0.606284 22.3496L11.0174 4.31707Z"
            fill="currentColor" />
    </svg>
</template>
